<script setup>
  import { ref, watch, onMounted } from 'vue';

  const props = defineProps({
    selectedLayout: {
      type: Number,
      default: 6,
    },
  });

  const emit = defineEmits(['change-per-row']);

  const changePerRow = (newValue) => {
    emit("change-per-row", newValue);
  };
</script>


<template>
  <div class="layout-controls">
    <div
      class="grid-colours-1"
      data-number="6"
      v-on:click="changePerRow(6)"
      :class="{ selected: selectedLayout === 6 }">
      <svg width="16" height="16" viewBox="0 0 16 16"
           fill="none">
        <rect width="6" height="6" rx="2" fill="#333" />
        <rect x="10" width="6" height="6" rx="2" fill="#333" />
        <rect y="10" width="6" height="6" rx="2" fill="#333" />
        <rect x="10" y="10" width="6" height="6" rx="2" fill="#333" />
      </svg>
    </div>
    <div
      class="grid-colours-2"
      data-number="3"
      v-on:click="changePerRow(3)"
      :class="{ selected: selectedLayout === 3 }">
      <svg width="16" height="16" viewBox="0 0 16 16"
           fill="none">
        <rect width="16" height="1" fill="#333" />
        <rect y="5" width="16" height="1" fill="#333" />
        <rect y="10" width="16" height="1" fill="#333" />
        <rect y="15" width="16" height="1" fill="#333" />
      </svg>
    </div>
  </div>
</template>

<style scoped>

</style>
